import Vue from "vue";
import VueRouter from "vue-router";
import UnAuthenticateLayout from "../layouts/UnAuthenticateLayout.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: UnAuthenticateLayout,
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: () =>
      import(
        /* webpackChunkName: "onboarding" */ "../layouts/AuthenticateLayout.vue"
      ),
  },
  {
    path: "/vendor-onboard",
    name: "VendorOnboarding",
    component: () =>
      import(
        /* webpackChunkName: "vendor-onboarding" */ "../views/vendor-onboarding/VendorOnboarding.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
